import React from "react";
import Head from "next/head";

import { propertyDetailsPage } from "i18n/messages/meta";
import getProjectTags from "constants/project_meta_tags";

const MetaTags = ({ projectID, locale, formatMessage, currentTenant }) => {
    const metaTags = React.useMemo(() => {
        const metaTag = getProjectTags(locale, projectID, currentTenant);
        return { ...metaTag, mainTitle: formatMessage(propertyDetailsPage.title) };
    }, [locale, projectID]);

    return (
        <Head>
            {Object.keys(metaTags).map((key, index) => {
                return key === "mainTitle" ? (
                    <title key={index}>{metaTags[key]}</title>
                ) : key === "ogURL" ? (
                    <meta key={index} property="og:url" content={metaTags[key]} />
                ) : key === "ogTitle" ? (
                    <meta key={index} property="og:title" content={metaTags[key]} />
                ) : key === "ogDescription" ? (
                    <meta key={index} property="og:description" content={metaTags[key]} />
                ) : key === "ogImage" ? (
                    <meta key={index} property="og:image" content={metaTags[key]} />
                ) : key === "ogImageURL" ? (
                    <meta key={index} property="og:image:url" content={metaTags[key]} />
                ) : key === "twitterImage" ? (
                    <meta key={index} property="twitter:image" content={metaTags[key]} />
                ) : null;
            })}
        </Head>
    );
};

export default MetaTags;
